import { LocaleTypes } from 'shared/i18n'

import { CatalogFilter, CatalogType } from 'modules/Catalog/model/types'
import { InfoType } from 'modules/Info/model/types'
import { OrdersType } from 'modules/Orders/model/types'
import { ReturnType } from 'modules/Return/model/types'

export interface AllPageParams {
  templateUuid?: string
}
export type AllParamsKeys = keyof AllParams
export type AllPageParamsKeys = keyof AllPageParams

export interface CommonParams extends CatalogFilter {
  limit?: number | string
  offset?: number | string
}
export type AllParams = CommonParams & {
  step: 'phone' | 'otp' | 'register'
  catalogType: CatalogType
  order: string
  orderType: OrdersType
  mplus: boolean
  isRecentlySeens: boolean
  infoType: InfoType
  categoryId: string
  isOpenSearch: boolean
  returnType: ReturnType
  isPanelOpen: boolean
  autoComplete: boolean
}

export interface AllPageParams {
  locale: LocaleTypes
  slug?: string
  [key: string]: string | string[] | undefined | undefined[] // Сигнатура индекса
}

export enum QueryParams {
  DISCOUNT = 'discounted',
  LIMIT = 'limit',
  OFFSET = 'offset',
  TAGS = 'tags',
  SEARCH = 'search',
  SORT = 'sort',
  CATEGORY = 'category',
}
